import React, {useContext} from 'react';

export const GlobalContext = React.createContext();

export const useGlobals = () => useContext(GlobalContext);
